export default __webpack_public_path__ + "static/media/bannerEcom.ac52da59.jpg";